"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styled = require("./styled");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var PaginationEndIcon = function PaginationEndIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "a",
    x1: ".5",
    x2: ".5",
    y2: "1",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "1"
  })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "b",
    y1: "-.18",
    x2: ".487",
    y2: ".657",
    href: "#a"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "url(#a)",
    opacity: ".63",
    d: "M2570.558 1061.678v4.582l-5.025-1.826z",
    transform: "translate(-2499.682 -1030.199)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "url(#b)",
    opacity: ".63",
    d: "M2597.44 1061.394v16.7l-88.334-12.88 82.714-.288z",
    transform: "translate(-2506.44 -1022.316)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "running-man",
    fill: "#9121C2",
    d: "M24.586 35H23.23a.676.676 0 0 1-.677-.674v-6.954a1.058 1.058 0 0 0-.448-.851l-5.828-3.86a1.348 1.348 0 0 1-.325-1.931l.217-.3 3.281-4.33h-2.1a1.055 1.055 0 0 0-.827.4l-1.966 2.7a.665.665 0 0 1-.95.148l-1.084-.782a.675.675 0 0 1-.163-.945l2.278-3.113A2.723 2.723 0 0 1 16.82 13.4h4.147a5.424 5.424 0 0 1 4.133 1.9l3.009 3.5a1.359 1.359 0 0 0 .773.486l2.615.526a.675.675 0 0 1 .5.676v1.35a.668.668 0 0 1-.25.522.674.674 0 0 1-.564.139l-2.874-.566a4.088 4.088 0 0 1-2.3-1.35l-1.694-2L21.2 22.7l2.859 1.944a2.694 2.694 0 0 1 1.205 2.256v7.425a.677.677 0 0 1-.678.675zm-9.962-5.4H9.678A.678.678 0 0 1 9 28.925v-1.35a.677.677 0 0 1 .678-.675h4.431a1.015 1.015 0 0 0 .813-.406l.935-1.268 2.29 1.5-1.355 1.8a2.727 2.727 0 0 1-2.168 1.074zm11.995-16.2a2.7 2.7 0 1 1 2.71-2.7 2.708 2.708 0 0 1-2.71 2.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cliff",
    fill: "none",
    stroke: "#9121C2",
    opacity: ".635",
    d: "M37.244 27.686s30.177.878 32.517 2.891-5.15 2.986-3.509 4.353 17.087 2.7 22.28 3.259-2.073 3.86-3.2 3.97-83.11 0-83.11 0"
  }));
};

PaginationEndIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "91",
  height: "55.779"
};

var Styled = _styledComponents["default"].div.withConfig({
  displayName: "PaginationEnd__Styled",
  componentId: "t7auyp-0"
})(function (_ref) {
  var _theme$brand$colors$p, _theme$brand, _theme$brand$colors, _theme$brand$colors$b, _theme$brand2, _theme$brand2$colors, _theme$brand$colors$p2, _theme$brand3, _theme$brand3$colors, _theme$brand$colors$p3, _theme$brand4, _theme$brand4$colors;

  var theme = _ref.theme;
  return {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: "1 0",
    color: (_theme$brand$colors$p = theme === null || theme === void 0 ? void 0 : (_theme$brand = theme.brand) === null || _theme$brand === void 0 ? void 0 : (_theme$brand$colors = _theme$brand.colors) === null || _theme$brand$colors === void 0 ? void 0 : _theme$brand$colors.primary) !== null && _theme$brand$colors$p !== void 0 ? _theme$brand$colors$p : "#9121c2",
    borderRadius: "6px",
    margin: "6px 0",
    backgroundColor: (_theme$brand$colors$b = theme === null || theme === void 0 ? void 0 : (_theme$brand2 = theme.brand) === null || _theme$brand2 === void 0 ? void 0 : (_theme$brand2$colors = _theme$brand2.colors) === null || _theme$brand2$colors === void 0 ? void 0 : _theme$brand2$colors.background) !== null && _theme$brand$colors$b !== void 0 ? _theme$brand$colors$b : "#F7F6F9",
    fontSize: 12,
    "svg .running-man": {
      fill: (_theme$brand$colors$p2 = theme === null || theme === void 0 ? void 0 : (_theme$brand3 = theme.brand) === null || _theme$brand3 === void 0 ? void 0 : (_theme$brand3$colors = _theme$brand3.colors) === null || _theme$brand3$colors === void 0 ? void 0 : _theme$brand3$colors.primary) !== null && _theme$brand$colors$p2 !== void 0 ? _theme$brand$colors$p2 : "#9121c2"
    },
    "svg .cliff": {
      stroke: (_theme$brand$colors$p3 = theme === null || theme === void 0 ? void 0 : (_theme$brand4 = theme.brand) === null || _theme$brand4 === void 0 ? void 0 : (_theme$brand4$colors = _theme$brand4.colors) === null || _theme$brand4$colors === void 0 ? void 0 : _theme$brand4$colors.primary) !== null && _theme$brand$colors$p3 !== void 0 ? _theme$brand$colors$p3 : "#9121c2"
    }
  };
});

function PaginationEnd(_ref2) {
  var _ref2$title = _ref2.title,
      title = _ref2$title === void 0 ? "" : _ref2$title;
  return /*#__PURE__*/_react["default"].createElement(Styled, null, /*#__PURE__*/_react["default"].createElement(_styled.Line, null), /*#__PURE__*/_react["default"].createElement(PaginationEndIcon, null), " ", title, /*#__PURE__*/_react["default"].createElement(_styled.Line, null));
}

var _default = PaginationEnd;
exports["default"] = _default;